import * as React from 'react';
import {connect} from 'react-redux';
import {WithStyles, withStyles, Menu, MenuItem, ListItemIcon, Checkbox, Divider, IconButton, Radio, Dialog, DialogTitle, Popover, } from '@material-ui/core';
import Button from '@components/common/button/Button';
import TranslateNew from '@translate/TranslateNew';
import * as EventActions from '@services/events/event.action';
import DateRangeIcon from '@material-ui/icons/DateRange';
import PhotoIcon from '@material-ui/icons/ImageRounded';
import DescIcon from '@material-ui/icons/SubjectRounded';
import CheckIcon from '@material-ui/icons/CheckCircleRounded';
import NotificationsIcon from '@material-ui/icons/NotificationsActiveRounded';
import PeopleIcon from '@material-ui/icons/PeopleAltRounded';
import CloseIcon from '@material-ui/icons/CloseRounded';
import AddIcon from '@material-ui/icons/AddRounded';
import ArrowIcon from '@material-ui/icons/ArrowForwardIosRounded';
import RepeatIcon from '@material-ui/icons/ReplayRounded';
import DeleteIcon from '@material-ui/icons/DeleteForeverRounded';
import CameraIcon from '@material-ui/icons/PhotoCameraRounded';
import ImageIcon from '@material-ui/icons/PanoramaOutlined';
import ImageCancelIcon from '@material-ui/icons/CancelPresentationOutlined';
import FileIcon from '@material-ui/icons/InsertDriveFileOutlined';
import {displayErrorMessage} from '@services/user/user.actions';

import { EditEventStyle } from './EditEvent.style';
import { IFamilyMember } from '@app-types/websocket/family.types';
import { IEvent, PRIVACY, REPEATABLE, ICreateNewEvent, IEditEvent, IDeleteEvent, IEventNotification, IAnalysedEvent, EVENT_TYPE } from '@app-types/websocket/event.types';
import { FamilyMemberType } from '@services/family/family.constants';
import ImgAvatar from '@components/common/avatar/ImgAvatar';
import { addDays, addMonths } from '@helpers/DateHelper';
import { DialogTop } from '@components/economy/DialogComponens';
import VVTimePicker from '@components/common/timepicker/VVTimePicker';
import VVDatePicker from '@components/common/timepicker/VVDatePicker';
import { secondaryColor, primaryColor, styleColors } from 'src/main.style';
import { IStuffBeingUploaded, IFinishedUpload, IUploadFile } from '@app-types/websocket/file.types';
import * as FileActions from '@services/file/file.actions';
import { handleBlobUpload, fileToBase64, mimeFromFilename, isImageFile, openFileInNewTab } from '@helpers/uploadHelper';
import AvatarEditor from 'react-avatar-editor';
import VVFullDatePicker from '@components/common/timepicker/VVFullDatePicker';
import PinchZoomImage from '@helpers/PinchZoomImage';

const tn: TranslateNew = TranslateNew.getInstance();

interface IState {
  iconSelectorOpen:boolean;
  visibleForOpen:boolean;
  showVisibleList:boolean;
  showNotificationsList:boolean;
  showMyNotificationsMenu:boolean;
  showNotificationsMenu:boolean;
  showRepeatMenu:boolean;
  showMoreOptions:boolean;

  titleTouched:boolean;

  dateStart:Date;
  dateEnd:Date;

  id:number;
  groupId?:number;
  title:string;
  description:string;
  startTime:number;
  endTime:number;
  hasTime:boolean;
 
  visible:number[];
  tagged:number[];
  notification:number[];
  customNotification:IEventNotification[];
  seen:number[];
  creator:number;
  checkmark:boolean;
  completedBy:number|undefined;

  repeatCount:string;
  repeat:REPEATABLE;
  lastRepeatDate:string;
  fileId?:number;

  confirm:"DELETE"|"UPDATE"|undefined;
  
  timeDate:"STARTDATE"|"STARTTIME"|"ENDDATE"|"ENDTIME"|null;
  timeDatePopupEl:HTMLDivElement|null;
  timeDateStyle:"QUICK"|"FULL";

  highlightTaggedSelector:boolean;

  updateNotificationAccountId:number|null;
  updateNotificationCurrentTime:number|null;
  updateNotificationRef:HTMLDivElement|null;

  nativeURL: string;
  includeAnalyzedImage:boolean;
  internalUploadId:number|undefined;
  saveClicked:boolean;
}

interface IProps extends WithStyles<typeof EditEventStyle> {
  userId:number,
  family:IFamilyMember[];
  close:(reason:"CLOSE"|"CREATED") => void;
  event: IEvent|undefined;
  onDate:Date|undefined;
  analysedEvent?: IAnalysedEvent;
  isOnline:boolean;
  allEvents: IEvent[];
  onOverlapsChange?: (overlaps: IEvent[]) => void;

  createEvent: (data: ICreateNewEvent) => void;
  deleteEvent: (data: IDeleteEvent) => void;
  editEvent: (data: IEditEvent) => void;

  uploadingFiles: IStuffBeingUploaded[];
  uploadedFiles: IFinishedUpload[];

  uploadFile: (file: IUploadFile) => void;
  uploadedFileUsed: (file: number) => void;
  removeStoredFile: (file: number) => void;
  displayErrorMessage: (msg: string) => void;

}

class EditEvent extends React.Component<IProps, IState> {
  private paneRef:React.RefObject<HTMLDivElement> = React.createRef();
  private iconRef:React.RefObject<HTMLDivElement> = React.createRef();
  private visibleRef:React.RefObject<HTMLDivElement> = React.createRef();
  private myNotificationsRef:React.RefObject<SVGSVGElement> = React.createRef();
  private notificationsRef:React.RefObject<SVGSVGElement> = React.createRef();
  private descRef:React.RefObject<HTMLTextAreaElement> = React.createRef();
  private repeatRef:React.RefObject<HTMLDivElement> = React.createRef();
  private startTimeRef:React.RefObject<HTMLDivElement> = React.createRef();
  private endTimeRef:React.RefObject<HTMLDivElement> = React.createRef();
  private startDateRef:React.RefObject<HTMLDivElement> = React.createRef();
  private endDateRef:React.RefObject<HTMLDivElement> = React.createRef();

  private imageRef:React.RefObject<HTMLImageElement> = React.createRef();
  private imageContainerRef:React.RefObject<HTMLDivElement> = React.createRef();

  private editorRef: React.RefObject<AvatarEditor> = React.createRef();
  
  // private fileInputRef: React.RefObject<HTMLInputElement> = React.createRef();
  private titleRef:React.RefObject<HTMLInputElement> = React.createRef();
  private repeatCountRef:React.RefObject<HTMLInputElement> = React.createRef();

  private lastOverlapKey:string = "__init__";

  constructor(props: IProps) {
    super(props);
    let event:IEvent;
    if (props.event) {
      event = JSON.parse(JSON.stringify(props.event));
    } else if (props.analysedEvent) {
      event = this.createEmptyEvent(props.onDate, props.userId);
      const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
      const timeRegex = /^\d{2}:\d{2}$/;
      if (props.analysedEvent.title)      {event.title = props.analysedEvent.title;}
      if (props.analysedEvent.description){event.description = props.analysedEvent.description;}
      if (props.analysedEvent.checkmark)  {event.checkmark = props.analysedEvent.checkmark;}

      if (props.analysedEvent.forAccountIds && props.analysedEvent.forAccountIds.length > 0) {
        const tagged = props.analysedEvent.forAccountIds
          .filter((accountId, index, ids) => ids.indexOf(accountId) === index)
          .filter((accountId) => props.family.some((mem) => mem.id === accountId));
        if (tagged.length > 0) { // unknown ids only: keep the default tagging
          event.tagged = tagged;
        }
      }

      if (props.analysedEvent.startDate && dateRegex.test(props.analysedEvent.startDate))  {
        const sta = new Date(event.startTime);
        const [y, m, d] = props.analysedEvent.startDate.split("-").map(Number);
        sta.setFullYear(y, m-1, d);
        event.startTime = sta.getTime();
      }
      if (props.analysedEvent.endDate && dateRegex.test(props.analysedEvent.endDate))  {
        const endd = new Date(event.endTime);
        const [y, m, d] = props.analysedEvent.endDate.split("-").map(Number);
        endd.setFullYear(y, m-1, d);
        event.endTime = endd.getTime();
      } else {
        event.endTime = event.startTime+(1000*60*60);
      }
      const hasStartTime = props.analysedEvent.startTime !== undefined && timeRegex.test(props.analysedEvent.startTime);
      const hasEndTime = props.analysedEvent.endTime !== undefined && timeRegex.test(props.analysedEvent.endTime);
      if (hasStartTime)  {
        const sta = new Date(event.startTime);
        const [h, m] = props.analysedEvent.startTime!.split(":").map(Number);
        sta.setHours(h);
        sta.setMinutes(m);
        event.startTime = sta.getTime();
      }
      if (hasEndTime)  {
        const endd = new Date(event.endTime);
        const [h, m] = props.analysedEvent.endTime!.split(":").map(Number);
        endd.setHours(h);
        endd.setMinutes(m);
        event.endTime = endd.getTime();
      }
      if (hasStartTime && !hasEndTime) {
        // only a start time: make the activity one hour long
        const endd = new Date(event.endTime);
        const sta = new Date(event.startTime);
        endd.setHours(sta.getHours() + 1);
        endd.setMinutes(sta.getMinutes());
        event.endTime = endd.getTime();
      } else if (hasEndTime && !hasStartTime) {
        // only an end time: make the activity one hour long
        const sta = new Date(event.startTime);
        const endd = new Date(event.endTime);
        sta.setHours(endd.getHours() - 1);
        sta.setMinutes(endd.getMinutes());
        event.startTime = sta.getTime();
      }

      if (props.analysedEvent.startDate && dateRegex.test(props.analysedEvent.startDate)
        && !hasStartTime && !hasEndTime) {
        // a date without any time: full day event, same convention as updateTimeFullday
        const sta = new Date(event.startTime);
        sta.setHours(0);
        sta.setMinutes(0);
        const endd = new Date(event.endTime);
        endd.setHours(23);
        endd.setMinutes(59);
        event.startTime = sta.getTime();
        event.endTime = endd.getTime();
        event.hasTime = false;
      }
    } else {
      event = this.createEmptyEvent(props.onDate, props.userId);
    }

    const start = new Date(event.startTime);
    const end = new Date(event.endTime);

    this.state = {
      iconSelectorOpen:false,
      visibleForOpen:false,
      showVisibleList:false,
      showNotificationsList:false,
      showMyNotificationsMenu:false,
      showNotificationsMenu:false,
      showRepeatMenu:false,
      showMoreOptions:false,
      titleTouched:false,

      dateStart:start,
      dateEnd:end,

      id:event.id,
      title:event.title,
      description:event.description?event.description:"",
      startTime:event.startTime,
      endTime:event.endTime,
      hasTime:event.hasTime,
      visible:event.visible?event.visible:[],
      tagged:event.tagged?event.tagged:[],
      notification:event.notification?event.notification:[],
      customNotification:event.customNotification?event.customNotification:[],
      seen:event.seen?event.seen:[],
      creator:event.creator,
      groupId:event.groupId,
      repeatCount:"2",
      repeat:REPEATABLE.ONCE,
      lastRepeatDate:"",
      confirm:undefined,
      fileId:event.file?event.file.id:undefined,
      checkmark:((event.checkmark !== undefined && event.checkmark ===  true)?true:false),
      completedBy:event.completedBy,

      timeDate:null,
      timeDatePopupEl:null,
      updateNotificationAccountId:null,
      updateNotificationCurrentTime:null,
      updateNotificationRef:null,

      highlightTaggedSelector: (props.event === undefined && props.family.filter((mem) => mem.role === FamilyMemberType.CHILD).length > 1),
      
      includeAnalyzedImage:false,
      internalUploadId:undefined,
      nativeURL:"",
      saveClicked:false,
      timeDateStyle:"QUICK",
    };
    this.updateDescSize();
  }

  public componentDidMount() {
    this.updateDescSize();
    this.notifyOverlaps();
  }

  public componentDidUpdate(prevProps: Readonly<IProps>): void {
    if (prevProps.uploadingFiles && this.props.uploadingFiles && this.props.uploadingFiles.length > prevProps.uploadingFiles.length) {
      const uploadingFile = this.props.uploadingFiles.find((f) => f.internalId === this.state.internalUploadId);
      if (uploadingFile && uploadingFile.id) {
        this.setState({fileId:uploadingFile.id});
      }
    }
    if (prevProps.uploadedFiles && this.props.uploadedFiles && this.props.uploadedFiles.length > prevProps.uploadedFiles.length) {
      const uploadedFile = this.props.uploadedFiles.find((f) => f.internalId === this.state.internalUploadId);
      if (uploadedFile && uploadedFile.id) {
        
        this.save(undefined);
        // this.setState({analyzingImageId:uploadedFile.id, fileId:uploadedFile.id});
      }
    }
    if (prevProps.event !== this.props.event) {
      let event:IEvent;
      if (this.props.event) {
        event = JSON.parse(JSON.stringify(this.props.event));
      } else {
        event = this.createEmptyEvent(this.props.onDate, this.props.userId);
      }

      const start = new Date(event.startTime);
      const end = new Date(event.endTime);

      this.setState({
        iconSelectorOpen:false,
        visibleForOpen:false,
        showVisibleList:false,  
        showNotificationsList:false,
        showMyNotificationsMenu:false,
        showNotificationsMenu:false,
        showRepeatMenu:false, 
        showMoreOptions:false, 
        titleTouched:false,

        dateStart:start,
        dateEnd:end,
  
        id:event.id,
        title:event.title,
        description:event.description?event.description:"",
        startTime:event.startTime,
        endTime:event.endTime,
        hasTime:event.hasTime,
        visible:event.visible?event.visible:[],
        tagged:event.tagged?event.tagged:[],
        notification:event.notification?event.notification:[],
        customNotification:event.customNotification?event.customNotification:[],
        seen:event.seen?event.seen:[],
        creator:event.creator,
        groupId:event.groupId,  
        repeatCount:"2",
        repeat:REPEATABLE.ONCE,
        lastRepeatDate:"",
        confirm:undefined,
        fileId:event.file?event.file.id:undefined,
        timeDate:null,
        timeDatePopupEl:null,
        updateNotificationAccountId:null,
        updateNotificationCurrentTime:null,
        updateNotificationRef:null,
        checkmark:((event.checkmark !== undefined && event.checkmark ===  true)?true:false),
        completedBy:event.completedBy,

        highlightTaggedSelector: false,
        
        includeAnalyzedImage:false,
        internalUploadId:undefined,
        nativeURL: "",
        saveClicked:false,
      });
      this.updateDescSize();
      if (this.paneRef.current) {
        this.paneRef.current.scrollTop = 0;
      }
    } else if (this.props.event === undefined && prevProps.onDate !== this.props.onDate) {
      const event = this.createEmptyEvent(this.props.onDate, this.props.userId);

      const start = new Date(event.startTime);
      const end = new Date(event.endTime);

      this.setState({
        iconSelectorOpen:false,
        visibleForOpen:false,  
        showVisibleList:false,
        showNotificationsList:false,
        showMyNotificationsMenu:false,
        showNotificationsMenu:false,
        showRepeatMenu:false,
        showMoreOptions:false,
  
        titleTouched:false,

        dateStart:start,
        dateEnd:end,

        id:event.id,
        title:event.title,
        description:event.description?event.description:"",
        startTime:event.startTime,
        endTime:event.endTime,
        hasTime:event.hasTime,
        fileId:event.file?event.file.id:undefined,
        visible:event.visible?event.visible:[],
        tagged:event.tagged?event.tagged:[],
        notification:event.notification?event.notification:[],
        customNotification:event.customNotification?event.customNotification:[],
        seen:event.seen?event.seen:[],
        creator:event.creator,
        groupId:event.groupId,  
        repeatCount:"2",
        repeat:REPEATABLE.ONCE,
        lastRepeatDate:"",
        confirm:undefined,
        timeDate:null,
        timeDatePopupEl:null,

        updateNotificationAccountId:null,
        updateNotificationCurrentTime:null,
        updateNotificationRef:null,
        checkmark:false,
        completedBy:undefined,
  
        highlightTaggedSelector: false,
     
        includeAnalyzedImage:false,
        internalUploadId:undefined,
        nativeURL: "",
        saveClicked:false,

      });
      this.updateDescSize();
      if (this.paneRef.current) {
        this.paneRef.current.scrollTop = 0;
      }
    }
    this.notifyOverlaps();
  }

  public render() {
    const {classes, family, userId} = this.props;
    const {id,title,description,creator,visible,tagged,notification,seen, dateEnd, dateStart, customNotification} = this.state;

    const disableAddImage = this.props.analysedEvent !== undefined;
    let disableSave = false;

    const uploadedFile: IFinishedUpload | undefined = this.props.uploadedFiles.find((f) => f.internalId === this.state.internalUploadId);
    const uploadingFile: IStuffBeingUploaded | undefined = this.props.uploadingFiles.find((f) => f.internalId === this.state.internalUploadId);

    let uploadContent = <div/>;
    let uploadedContent = <div/>;
    if (this.props.analysedEvent !== undefined && this.props.analysedEvent.imageUrl !== undefined) {
      uploadContent = <div ref={this.imageContainerRef}
        style={{position:'relative', overflow: 'auto', maxHeight: this.state.includeAnalyzedImage?'250px':'0px', margin:'0px 14px',
        border:this.state.includeAnalyzedImage?'1px solid #00000087':'0px solid #00000087', borderRadius:'4px', transition: 'all 0.3s'}}>
          <PinchZoomImage src={this.props.analysedEvent.imageUrl} alt='Analyzed Image'/>
          {/* <img src={this.props.analysedEvent.imageUrl} alt="Analyzed image" onLoad={() => this.centerImage()} ref={this.imageRef}/> */}
          
        </div>
    } else if (this.state.nativeURL !== '') {
      // disableAddImage = true;
      if (uploadedFile) {
        disableSave = true;
        uploadContent = <div style={{position:'relative'}}>
          <div className={classes.disableEdit}>
            {tn.lang.uploading+" "+tn.lang.done}
          </div>
          <AvatarEditor
            ref={this.editorRef}
            image={this.state.nativeURL}
            style={{ width: "100%", height: "100%", maxWidth: "400px", maxHeight: "400px" }}
            border={0}
            width={900}
            height={900}
            borderRadius={0}
            color={[255, 255, 255, 1]}
            scale={1}
            rotate={0}
          /></div>
      } else if (uploadingFile) {
        disableSave = true;
        if (uploadingFile.loaded === 100 && uploadingFile.id) {
          uploadContent = <div style={{position:'relative', overflow: 'hidden', maxHeight: '400px', transition: 'all 0.3s'}}>
          <div className={classes.disableEdit}>
          {tn.lang.uploading+" "+tn.lang.done}
          </div>
          <AvatarEditor
            ref={this.editorRef}
            image={this.state.nativeURL}
            style={{ width: "100%", height: "100%", maxWidth: "400px", maxHeight: "400px"}}
            border={0}
            width={900}
            height={900}
            borderRadius={0}
            color={[255, 255, 255, 1]}
            scale={1}
            rotate={0}
          /></div>
        } else {
          uploadContent = <div style={{position:'relative', overflow: 'hidden', maxHeight: '400px', transition: 'all 0.3s'}}>
          <div className={classes.disableEdit}>
            {tn.lang.uploading+(uploadingFile?(" "+uploadingFile.loaded):"...")}
          </div>
          <AvatarEditor
            ref={this.editorRef}
            image={this.state.nativeURL}
            style={{ width: "100%", height: "100%", maxWidth: "400px", maxHeight: "400px" }}
            border={0}
            width={900}
            height={900}
            borderRadius={0}
            color={[255, 255, 255, 1]}
            scale={1}
            rotate={0}
          /></div>
        }
      } else {
        disableSave = false;
        uploadContent = <div style={{position:'relative', overflow: 'hidden', maxHeight: '400px', transition: 'all 0.3s'}}>
          <div className={classes.enableEdit} />
          <AvatarEditor
            ref={this.editorRef}
            image={this.state.nativeURL}
            style={{ width: "100%", height: "100%", maxWidth: "400px", maxHeight: "400px" }}
            border={0}
            width={900}
            height={900}
            borderRadius={0}
            color={[255, 255, 255, 1]}
            scale={1}
            rotate={0}
          /></div>
      }

      if (this.props.event && this.props.event.id > 0) {
        uploadedContent = 
          (<div className={classes.section} style={{maxHeight:'1000px'}}>
            <div className={classes.row} >
              <div className={classes.leftColumn} ><PhotoIcon className={classes.greyIcon}/></div>
              <div className={classes.rightColumn} >
                <div className={classes.fullwidth}>{tn.lang.calImage}</div>
              </div>
            </div>
            <div className={classes.row} style={{maxHeight:'500px'}}>  
              {uploadContent}
            </div>
          </div>);
        uploadContent = <div style={{position:'relative', overflow: 'hidden', maxHeight: '0px', transition: 'all 0.3s'}} />
      }
    } else if (this.props.event && this.props.event.file && this.props.event.file.url && this.state.fileId) {
      const storedFile = this.props.event.file;
      const storedFileUrl:string = this.props.event.file.url;
      uploadedContent = isImageFile(storedFile.fileName)
        ?(<div className={classes.section} style={{maxHeight:'1000px'}}>
          <div className={classes.row} >
            <div className={classes.leftColumn} ><PhotoIcon className={classes.greyIcon}/></div>
            <div className={classes.rightColumn} >
              <div className={classes.fullwidth}>{tn.lang.calImage}</div>
            </div>
          </div>
          <div className={classes.row} style={{maxHeight:'1000px'}}>
            <div className={classes.leftColumn} />
            <div className={classes.rightColumn} style={{position:'relative'}}>
              <CloseIcon style={{fill:"#fff", top:0, right:0, position:"absolute", zIndex: 2, margin:'5px',
                background:'radial-gradient(circle, rgb(0 0 0 / 48%) 0%, rgba(0, 0, 0, 0) 68%)'}}
                onClick={() => this.setState({fileId:undefined})}/>
              <PinchZoomImage  src={storedFileUrl} alt={storedFile.fileName} className={classes.fullwidth}/>
             {/* <img className={classes.fullwidth} src= {this.props.event.file.url} alt={this.props.event.file.fileName}/> */}

            </div>
          </div>
        </div>)
        :(<div className={classes.section} style={{maxHeight:'1000px'}}>
          <div className={classes.row} >
            <div className={classes.leftColumn} ><FileIcon className={classes.greyIcon}/></div>
            <div className={classes.rightColumn} >
              <div className={classes.fullwidth}>{tn.lang.calFile}</div>
            </div>
          </div>
          <div className={classes.row} >
            <div className={classes.leftColumn} />
            <div className={classes.rightColumn} style={{position:'relative'}}>
              <CloseIcon className={classes.greyIcon} style={{top:0, right:0, position:"absolute", zIndex: 2, margin:'5px'}}
                onClick={() => this.setState({fileId:undefined})}/>
              <a href={storedFileUrl} target="_blank" rel="noopener noreferrer"
                style={{display:'flex', alignItems:'center', color:secondaryColor, textDecoration:'none', padding:'8px 0px'}}
                onClick={(e) => {e.preventDefault(); openFileInNewTab(storedFileUrl);}}>
                <FileIcon style={{fontSize:'40px', fill:secondaryColor}}/>
                <span style={{marginLeft:'8px', wordBreak:'break-all'}}>{storedFile.fileName}</span>
              </a>
            </div>
          </div>
        </div>);
    } else if (!uploadedFile && !uploadingFile ) {
      uploadContent = <div style={{position:'relative', overflow: 'hidden', maxHeight: '0px', transition: 'all 0.3s'}} />
      uploadedContent = 
        (<div className={classes.section} style={{maxHeight:'1000px'}}>
          <div className={classes.row} >
            <div className={classes.leftColumn} ><PhotoIcon className={classes.greyIcon}/></div>
            <div className={classes.rightColumn} >
              <div className={classes.fullwidth}>{tn.lang.calImage}</div>
            </div>
            <label htmlFor="add-file2">
              <input type="file" multiple={false} style = {{opacity:0, position:'absolute'}} accept="capture=camera,image/*" 
                id={"add-file2"} onChange={this.updateLocalImage} />
              <div style={{ pointerEvents: 'none'}}>
                <AddIcon className={classes.greyBackgroundIcon} />
              </div>
            </label>
          </div>
        </div>);
    }

    const thirtyDaysBack = Date.now() - (1000*60*60*24*30);
    let hasGlow = false;

    const see = family.map((person) => {
      let glow:string|undefined;
      if (person.role === FamilyMemberType.DELETED || person.role === FamilyMemberType.EXPERT || person.role === FamilyMemberType.MODERATOR) {
        return <div key={person.id} style={{marginTop: '-8px'}}/>
      }
      let row = classes.row;
      if (!this.state.showVisibleList) {row = row +" "+classes.rowHidden;}
      else if (!visible.includes(person.id)) {row = row +" "+classes.rowHidden;}
      const avatar = <ImgAvatar altText={person.firstName} imgUrl={person.imageAvatar?person.avatarURL:undefined}
        imgName={person.avatar} style={{width:'20px', height:'20px', alignSelf: 'center', marginRight: '8px'}} color={person.color} />
      let subTitle = "";
      
      let deletable = true;
      if (person.id === creator) {
        subTitle = tn.lang.calEventCreator;
        deletable = false;
      }
      if (!seen.includes(person.id) && person.lastOnline && person.lastOnline > 0 && id > 0) {
        subTitle =  subTitle + tn.lang.calEventNotSeen;
        if (person.lastOnline > thirtyDaysBack && visible.includes(person.id)
          && (person.role === FamilyMemberType.PARENT || person.role === FamilyMemberType.CHILD)) {
          glow= "0 0 10px #FFA800";
          hasGlow = true;
        }
      } else if (person.lastOnline === undefined || person.lastOnline === 0) {
        subTitle = subTitle + tn.lang.calEventNoAccount;
      }
      if (person.id === userId) {
        deletable = false;
        if (subTitle.length === 0) {subTitle=tn.lang.youSub;}
      }

      return (<div className={row} key={person.id}>
        <div className={classes.leftColumn} />
        <div className={classes.rightColumn} >
          {avatar}
          <div className={classes.fullwidth + " " +classes.person}>
            <span>{person.firstName}</span>
            <span className={classes.personSubtitle} style={{textShadow:glow}}>{subTitle}</span>
          </div>
          <CloseIcon className={classes.greyIcon} style={deletable?{}:{opacity:0.5}} 
            onClick={() => {if (deletable) {this.updateVisible(person.id, false)}}}/>
        </div>
        </div>);
      }
    );

    let taggedIcons:JSX.Element[] = [];
    if (tagged.length === 0) {
      taggedIcons.push(<AddIcon className={classes.greyBackgroundIcon} key="base"/>);
    } else {
      taggedIcons = tagged.map((tag:number, index:number) => {
        const person = family.find((p) => p.id === tag);
        if (person) {
          return (<ImgAvatar altText={person.firstName} imgUrl={person.imageAvatar?person.avatarURL:undefined}
            imgName={person.avatar} style={{width:'20px', height:'20px', border: '1px solid #fff', marginLeft:(index>0?-10:0)}} 
            color={person.color} key={tag}/>);
        } else {
          return (<div key={tag}/>);
        }
      });
    }

    const visibleIcons = visible.map((tag:number, index:number) => {
      const person = family.find((p) => p.id === tag);
      if (person) {
        return (<ImgAvatar altText={person.firstName} imgUrl={person.imageAvatar?person.avatarURL:undefined}
          imgName={person.avatar} style={{width:'20px', height:'20px', border: '1px solid #fff', marginLeft:(index>0?-10:0)}} 
          color={person.color} key={tag}/>);
      } else {
        return (<div key={tag}/>);
      }
    });


    const alerts:JSX.Element[] = [];
    alerts.push(<div className={classes.section} key={userId}>
      <div className={classes.row}>
        <div className={classes.leftColumn} ><NotificationsIcon className={classes.greyIcon}/></div>
        <div className={classes.rightColumn}  onClick={() => this.setState({showMyNotificationsMenu:!this.state.showMyNotificationsMenu})}>
          <div className={classes.fullwidth}>{tn.lang.calEventYourNotifications}</div>
          <AddIcon className={classes.greyBackgroundIcon} ref={this.myNotificationsRef}/>
        </div>
      </div>
      <div className={classes.row+((this.hasReminder(userId,0))?"":(" "+classes.rowHidden))}>
        <div className={classes.leftColumn} />
        <div className={classes.fullwidth}>{tn.lang.calReminder0Min}</div>
        <CloseIcon className={classes.greyIcon} onClick={() => this.setState(this.updateReminder(userId,0))}/>
      </div>
      <div className={classes.row+((this.hasReminder(userId,5))?"":(" "+classes.rowHidden))}>
        <div className={classes.leftColumn} />
        <div className={classes.fullwidth}>{tn.lang.calReminder5Min}</div>
        <CloseIcon className={classes.greyIcon} onClick={() => this.setState(this.updateReminder(userId,5))}/>
      </div>
      <div className={classes.row+((this.hasReminder(userId,10))?"":(" "+classes.rowHidden))}>
        <div className={classes.leftColumn} />
        <div className={classes.fullwidth}>{tn.lang.calReminder10Min}</div>
        <CloseIcon className={classes.greyIcon} onClick={() => this.setState(this.updateReminder(userId,10))}/>
      </div>
      <div className={classes.row+((notification.includes(userId))?"":(" "+classes.rowHidden))}>
        <div className={classes.leftColumn} />
        <div className={classes.fullwidth}>{tn.lang.calReminder15Min}</div>
        <CloseIcon className={classes.greyIcon} onClick={() => this.setState(this.updateReminder(userId,15))}/>
      </div>
      <div className={classes.row+((this.hasReminder(userId,30))?"":(" "+classes.rowHidden))}>
        <div className={classes.leftColumn} />
        <div className={classes.fullwidth}>{tn.lang.calReminder30Min}</div>
        <CloseIcon className={classes.greyIcon} onClick={() => this.setState(this.updateReminder(userId,30))}/>
      </div>
      <div className={classes.row+((this.hasReminder(userId,60))?"":(" "+classes.rowHidden))}>
        <div className={classes.leftColumn} />
        <div className={classes.fullwidth}>{tn.lang.calReminder60Min}</div>
        <CloseIcon className={classes.greyIcon} onClick={() => this.setState(this.updateReminder(userId,60))}/>
      </div>
      <div className={classes.row+((this.hasReminder(userId,120))?"":(" "+classes.rowHidden))}>
        <div className={classes.leftColumn} />
        <div className={classes.fullwidth}>{tn.lang.calReminder120Min}</div>
        <CloseIcon className={classes.greyIcon} onClick={() => this.setState(this.updateReminder(userId,120))}/>
      </div>
      <div className={classes.row+((this.hasReminder(userId,720))?"":(" "+classes.rowHidden))}>
        <div className={classes.leftColumn} />
        <div className={classes.fullwidth}>{tn.lang.calReminder12H}</div>
        <CloseIcon className={classes.greyIcon} onClick={() => this.setState(this.updateReminder(userId,120))}/>
      </div>
      <div className={classes.row+((this.hasReminder(userId,1440))?"":(" "+classes.rowHidden))}>
        <div className={classes.leftColumn} />
        <div className={classes.fullwidth}>{tn.lang.calReminder1Day}</div>
        <CloseIcon className={classes.greyIcon} onClick={() => this.setState(this.updateReminder(userId,1440))}/>
      </div>      
      <div className={classes.row+((this.hasReminder(userId,2880))?"":(" "+classes.rowHidden))}>
        <div className={classes.leftColumn} />
        <div className={classes.fullwidth}>{tn.lang.calReminder2Day}</div>
        <CloseIcon className={classes.greyIcon} onClick={() => this.setState(this.updateReminder(userId,2880))}/>
      </div>
    </div>);

    alerts.push(<div className={classes.section+(visible.length === 1?(" "+classes.sectionHidden):"")} key={"others"}>
      <div className={classes.row}>
        <div className={classes.leftColumn} ><NotificationsIcon className={classes.greyIcon}/></div>
        <div className={classes.rightColumn} >
          <div className={classes.fullwidth} style={{justifyContent: 'space-between', display: 'flex', alignItems: 'center', marginRight: '20px'}}
            onClick={() => this.setState({showNotificationsList:!this.state.showNotificationsList})}>
            <span>{tn.lang.calEventOthersNotificationsShow}</span>
            <ArrowIcon className={classes.greyIcon} style={{transition:'all 0.3s', rotate:(this.state.showNotificationsList?'-90deg':'90deg')}}/>
          </div>
          <AddIcon className={classes.greyBackgroundIcon}  ref={this.notificationsRef} 
            onClick={() => this.setState({showNotificationsMenu:!this.state.showNotificationsMenu})}/>
        </div>
      </div>
      {family
        .filter((mem) => (mem.id !== userId && mem.role !== FamilyMemberType.EXPERT && mem.role !== FamilyMemberType.DELETED 
          && mem.role !== FamilyMemberType.MODERATOR))
        .map((mem) => <div className={classes.row+((notification.includes(mem.id) && this.state.showNotificationsList)?"":(" "+classes.rowHidden))}
          key={mem.id}>
          <div className={classes.leftColumn} />
          <div className={classes.rightColumn} >
            <ImgAvatar altText={mem.firstName} imgUrl={mem.imageAvatar?mem.avatarURL:undefined}
              imgName={mem.avatar} style={{width:'20px', height:'20px', alignSelf: 'center', marginRight: '8px'}} color={mem.color} />
            <div className={classes.fullwidth + " " +classes.person} onClick={(e) => 
                this.setState({updateNotificationAccountId:mem.id,updateNotificationCurrentTime:15, updateNotificationRef:e.currentTarget})}>
              <span>{mem.firstName}</span>
              <span className={classes.personSubtitle}>{tn.lang.calReminder15Min}</span>
            </div>
            <CloseIcon className={classes.greyIcon} onClick={() => this.setState(this.updateReminder(mem.id,15))}/>
          </div>
        </div>)}
      {customNotification
        .filter((cnot) => (cnot.accountId !== userId))
        .map((cnot) => <div className={classes.row+((this.state.showNotificationsList)?"":(" "+classes.rowHidden))} 
          key={cnot.accountId+"-"+cnot.timeDelta}>
          <div className={classes.leftColumn} />
          <div className={classes.rightColumn} >
            {tn.avatar(family, cnot.accountId,{width:'20px', height:'20px', alignSelf: 'center', marginRight: '8px'})}
            <div className={classes.fullwidth + " " +classes.person} onClick={(e) => 
                this.setState({updateNotificationAccountId:cnot.accountId,updateNotificationCurrentTime:cnot.timeDelta/60000, 
                updateNotificationRef:e.currentTarget})}>
              <span>{tn.familyMemberName(cnot.accountId, family)}</span>
              <span className={classes.personSubtitle}>{tn.lang.calReminderName(cnot.timeDelta/60000)}</span>
            </div>
            <CloseIcon className={classes.greyIcon} onClick={() => this.setState(this.updateReminder(cnot.accountId,cnot.timeDelta/(60000)))}/>
          </div>
        </div>)}
      </div>);


    const repeat:JSX.Element = (
      <div className={classes.section} style={this.state.id>0?{display:'none'}:{}}>
          <div className={classes.row}>
            <div className={classes.leftColumn} style={{alignSelf: 'flex-start', paddingTop: '2px'}}>
              <RepeatIcon className={classes.greyIcon}/></div>
            <div className={classes.rightColumn} onClick={() => this.setState({showRepeatMenu:!this.state.showRepeatMenu})} >
              <div className={classes.fullwidth} >
                {tn.lang.eventReoccuring}
              </div>
              <div ref={this.repeatRef} style={{display:'flex'} }>
                <AddIcon className={classes.greyBackgroundIcon} />
              </div>
            </div>
          </div> 
      <div className={classes.row +(this.state.repeat===REPEATABLE.ONCE?(" "+classes.rowHidden):"")}>
        <div className={classes.leftColumn} />
        <div className={classes.rightColumn} >
          <div className={classes.fullwidth}>
            {this.state.repeat === REPEATABLE.WEEKLY
              ?tn.lang.eventWeekly
              :this.state.repeat === REPEATABLE.BI_WEEKLY
                ?tn.lang.eventBiWeekly
                :tn.lang.todoRenewNo}
          </div>
          <CloseIcon className={classes.greyIcon} onClick={() => this.setState({repeat:REPEATABLE.ONCE, repeatCount:"2"})}/>
        </div>
      </div>

      <div className={classes.row +(this.state.repeat===REPEATABLE.ONCE?(" "+classes.rowHidden):"")}>
      <div className={classes.leftColumn} />
      <div className={classes.rightColumn} >
        <div className={classes.fullwidth}>
          {tn.lang.eventOccurences}
        </div>
        <input
          ref={this.repeatCountRef}
          id="event-repeat-count"
          type="number"
          pattern="[0-9]*" 
          inputMode="numeric"
          value={this.state.repeatCount}
          maxLength={5}
          onBlur={() => {
            if (this.state.repeatCount.trim().length === 0 || isNaN(parseInt(this.state.repeatCount,10)) 
            ||  parseInt(this.state.repeatCount,10) < 2) {
              this.setState({repeatCount:"2",repeat:REPEATABLE.ONCE});
            } else if (parseInt(this.state.repeatCount,10) > 50) {
              this.setState({repeatCount:"50"});
            }
          }}
          onChange={(event) => {
            let repeatC = 2;
            let lastDate = "";
            if (event.target.value.trim().length === 0 || isNaN(parseInt(event.target.value,10)) 
            ||  parseInt(event.target.value,10) < 2) {
              repeatC = 1;
              lastDate="";
            } else if (parseInt(event.target.value,10) > 50) {
              repeatC = 50
              lastDate=tn.lang.momentNewEvent(this.calcLastEvent(repeatC, this.state.repeat).getTime());
            } else {
              repeatC = parseInt(event.target.value,10)
              lastDate=tn.lang.momentNewEvent(this.calcLastEvent(repeatC, this.state.repeat).getTime());
            }
            this.setState({repeatCount:event.target.value, lastRepeatDate:lastDate})
          }}
          className={classes.greyInput}
          style={{maxWidth:"120px"}}
          placeholder={tn.lang.eventOccurences}/>
      </div>
    </div>
    
    
    
    <div className={classes.row +(this.state.repeat===REPEATABLE.ONCE?(" "+classes.rowHidden):"")}>
      <div className={classes.leftColumn} />
      <div className={classes.rightColumn} >
        <div className={classes.fullwidth}>
          {tn.lang.eventLastOccurence}
        </div>
        <input
          id="event-repeat-end"
          type="text"
          disabled={true}
          value={this.state.lastRepeatDate}
          className={classes.greyInput}
          style={{maxWidth:"120px"}}
          placeholder={tn.lang.eventLastOccurence}/>
      </div>
    </div>
    </div>);

    const desc:JSX.Element = (<div className={classes.section} >
      <div className={classes.row} style={{maxHeight:'unset'}}>
        <div className={classes.leftColumn} style={{alignSelf: 'flex-start', paddingTop: '2px'}}><DescIcon className={classes.greyIcon}/></div>
        <div className={classes.rightColumn} >
          <textarea
            ref={this.descRef}
            id="event-description"
            autoCorrect={"on"}
            rows={1}
            spellCheck={true}
            value={description}
            onChange={(event) => {this.updateDescSize(); this.setState({description:event.target.value});}}
            className={classes.greyInput + " " +classes.fullwidthInput}
            style={{lineHeight:'16px', resize:'none'}}
            placeholder={tn.lang.labelDescription}/>
        </div>
      </div>
      <div className={classes.row} style={{maxHeight:'unset'}} onClick={() => this.setState({checkmark:!this.state.checkmark})}>
        <div className={classes.leftColumn} style={{alignSelf: 'flex-start', paddingTop: '2px'}}>
          {this.state.checkmark?<CheckIcon style={{color:primaryColor}}/>:<CheckIcon style={{color:styleColors.greyLight2}}/>}
        </div>
        <div className={classes.rightColumn}>
          <span style={{display:'flex'}}>{tn.lang.calHasCheckmark}</span>
        </div>
      </div>
    </div>);

    const now = Date.now();
    let weirdStartDate:boolean = (dateStart.getTime() > (now + 1000*60*60*24*300));
    let weirdEndDate:boolean = (dateEnd.getTime() > (now + 1000*60*60*24*300));

    if (this.props.event === undefined) {
      if (dateStart.getTime() < (now - 1000*60*60*24*10)) {
        weirdStartDate = true;
      }
      if (dateEnd.getTime() < (now - 1000*60*60*24*10)) {
        weirdEndDate = true;
      }
    }

    if (dateStart.getTime() > dateEnd.getTime() && this.state.timeDate === null) {
      weirdStartDate = true;
      weirdEndDate = true;
    }

    return (<>
    <div  className={classes.scrollView} ref={this.paneRef}>
      {uploadContent}
      <div className={classes.pane}>
        <div className={classes.section} >
          <div className={classes.row}>
            <div className={classes.leftColumn + (this.state.highlightTaggedSelector?(" "+classes.highlight):"")} ref={this.iconRef} 
              onClick={() => this.setState({iconSelectorOpen:!this.state.iconSelectorOpen, highlightTaggedSelector:false})}>
              {taggedIcons}
            </div>
             <div className={classes.rightColumn} style={{ flexDirection: 'column'}} > 
              <input
                ref={this.titleRef}
                id="event-title"
                type="text"
                value={title}
                spellCheck={true}
                maxLength={45}
                onBlur={() => this.setState({titleTouched:true})}
                onChange={(event) => {this.setState({title:event.target.value})}}
                className={classes.rightColumn + " " +classes.greyInput + " " +classes.fullwidthInput}
                placeholder={tn.lang.labelTitle}/>
              <div className={classes.error} style={(title.length === 0 && this.state.titleTouched)?{maxHeight:'16px'}:{}}>
                {tn.lang.calTitleMustBeSet}</div>
            </div>
          </div>
        </div>
        <div className={classes.section} >
          <div className={classes.row} >
            <div className={classes.leftColumn} ><DateRangeIcon className={classes.greyIcon}/></div>
            <div className={classes.rightColumn} >
            <div className={classes.fullwidth}>{tn.lang.eventStart}</div>
              <div className={classes.greyInput + " " +classes.date} ref={this.startDateRef}
                style={weirdStartDate?{color:primaryColor}:{}}
                onClick={() => this.setState({timeDate:"STARTDATE", timeDatePopupEl:this.startDateRef.current,
                  timeDateStyle:weirdStartDate?"FULL":"QUICK"})}>
                {tn.formatDateDayMonthYear(dateStart)}
              </div>
              <div className={classes.greyInput + " " +classes.time} ref={this.startTimeRef}
                onClick={() => this.setState({timeDate:"STARTTIME", timeDatePopupEl:this.startTimeRef.current})}>
                {(!this.state.hasTime)?tn.lang.timePickerFullDay:tn.formatTime(dateStart)}
              </div>
            </div>
          </div>
          <div className={classes.row}>
            <div className={classes.leftColumn} />
            <div className={classes.rightColumn} >
              <div  className={classes.fullwidth}>{tn.lang.eventEnd}</div>
              <div className={classes.greyInput + " " +classes.date} ref={this.endDateRef}
                style={weirdEndDate?{color:primaryColor}:{}}
                onClick={() => this.setState({timeDate:"ENDDATE", timeDatePopupEl:this.endDateRef.current,
                  timeDateStyle:weirdEndDate?"FULL":"QUICK"})}>
                {tn.formatDateDayMonthYear(dateEnd)}
              </div>
              <div className={classes.greyInput + " " +classes.time} ref={this.endTimeRef}
                onClick={() => this.setState({timeDate:"ENDTIME", timeDatePopupEl:this.endTimeRef.current})}>
                {(!this.state.hasTime)?tn.lang.timePickerFullDay:tn.formatTime(dateEnd)}
              </div>
            </div>
          </div>
        </div>

        {this.props.analysedEvent === undefined?repeat:desc}
        
        <div className={classes.moreOptions} style={this.state.showMoreOptions?{}:{maxHeight:0}}>
          {this.props.analysedEvent === undefined?desc:repeat}
          <div className={classes.section} style={{maxHeight:'unset'}}>
            <div className={classes.row}>
              <div className={classes.leftColumn}>
                <PeopleIcon className={classes.greyIcon} /></div>
              <div className={classes.rightColumn} >
                <div className={classes.fullwidth} onClick={() => this.setState({showVisibleList:!this.state.showVisibleList})}
                  style={{justifyContent: 'space-between', display: 'flex', alignItems: 'center', marginRight: '20px'}}>
                  <span style={{display:'flex'}}>{tn.lang.todoVisibleTooltip}{yellowDot(hasGlow, true)}</span>
                  <span style={{display:'flex'}}>{visibleIcons}</span>
                </div>
                <div ref={this.visibleRef} style={{display:'flex'}}
                  onClick={() => this.setState({visibleForOpen:!this.state.visibleForOpen})}>
                  <AddIcon className={classes.greyBackgroundIcon} />
                </div>
              </div>
            </div>
            {see}
          </div>
          {alerts}
          {uploadedContent}
        </div>
        <div className={classes.section} style={{borderBottom: '0px', flexDirection: 'row', alignItems: 'center', alignSelf: 'center'}}
          onClick={() => this.setState({showMoreOptions:!this.state.showMoreOptions})}>
          
            <span style={{display:'flex'}}>
              {tn.lang.calMoreOptions}{yellowDot(hasGlow,!this.state.showMoreOptions)}
            </span>
            <ArrowIcon className={classes.greyIcon} style={{transition:'all 0.3s', rotate:(this.state.showMoreOptions?'-90deg':'90deg')}}/>
        
        </div>
        <div style={{width:'100%', height:'50px'}}/>
      </div>
      <div className={classes.actions} >
        <IconButton style={this.state.id===0?{display:'none'}:{padding:'8px 4px'}} onClick={() => this.delete(undefined)}>
          <DeleteIcon style={{fontSize:'30px'}}/>
        </IconButton>
        <Button variant="outlined"  classes={{outlined:classes.buttonOutlinedLarge}} onClick={() => this.props.close("CLOSE")}>
          {this.props.analysedEvent === undefined?tn.lang.cancel:tn.lang.discard}
        </Button>
        {this.props.analysedEvent === undefined
          ?<label htmlFor="add-file" style = {this.state.id === 0?(disableAddImage?{pointerEvents:'none'}:{}):{display:'none'}}>
            <input type="file" multiple={false} style = {{opacity:0, position:'absolute'}} accept="capture=camera,image/*" 
              id={"add-file"} onChange={this.updateLocalImage} />
            <div style={{ pointerEvents: 'none', padding: '12px'}}>
              <CameraIcon style={{fontSize:'30px', fill:disableAddImage?"#ddd":secondaryColor}} />
            </div>
          </label>
          :(this.props.analysedEvent && this.props.analysedEvent.fileUrl && !this.props.analysedEvent.imageUrl)
            ?<IconButton onClick={() => this.openAnalysedFile()}>
              <FileIcon style={{fontSize:'30px', fill:secondaryColor}}/>
            </IconButton>
            :(this.state.includeAnalyzedImage===false && this.props.analysedEvent && this.props.analysedEvent.imageUrl
            && this.props.analysedEvent.imageUrl !== "" && this.props.analysedEvent.fileId)
            ?<div className={classes.imgButton} onClick={() => this.setState({includeAnalyzedImage:true})} >
              <img className={classes.imgThumb} src={this.props.analysedEvent.imageUrl} alt="Analyzed image" />
            </div>
            :<IconButton onClick={() => this.setState({includeAnalyzedImage:false})}>
                <ImageCancelIcon style={{fontSize:'30px'}}/>
            </IconButton>}
        <Button variant="contained" onClick={() => this.saveOrUpload(undefined)} disabled={!this.validToSave() || disableSave} color="primary" 
          classes={{contained:classes.buttonContainedLarge}}>{tn.lang.save}</Button>
      </div>
    </div>
    <Popover 
      anchorEl={this.state.timeDatePopupEl}
      onClose={() => {this.onBlur(this.state.timeDate); this.setState({timeDate:null})}}
      open={(this.state.timeDate === "STARTTIME" || this.state.timeDate === "ENDTIME")}
      disableScrollLock={true}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <VVTimePicker 
        fullDayOption={true} setFullDay={() => {this.updateTimeFullday(); 
          setTimeout(() => this.setState({timeDate:null}), 500);}}
        isFullDay={!this.state.hasTime}
        open={(this.state.timeDate === "STARTTIME" || this.state.timeDate === "ENDTIME")}
        hour={this.getHourMinute(this.state.timeDate, "HOUR")}
        minute={this.getHourMinute(this.state.timeDate, "MINUTE")}
        setHour={(hour:number) => this.updateTime(this.state.timeDate, hour, null)}
        setMinute={(minute:number) => this.updateTime(this.state.timeDate, null, minute)}
      />
    </Popover>
    <Popover 
      anchorEl={this.state.timeDatePopupEl}
      onClose={() => {this.onBlur(this.state.timeDate); this.setState({timeDate:null})}}
      open={(this.state.timeDate === "STARTDATE" || this.state.timeDate === "ENDDATE")}
      disableScrollLock={true}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      {this.state.timeDateStyle === "QUICK"
        ?<VVDatePicker 
          open={(this.state.timeDate === "STARTDATE" || this.state.timeDate === "ENDDATE")}
          date={this.getDate(this.state.timeDate)}
          setDate={(date:Date) => this.updateDate(this.state.timeDate, date)}
        />
        :<VVFullDatePicker
          open={(this.state.timeDate === "STARTDATE" || this.state.timeDate === "ENDDATE")}
          date={this.getDate(this.state.timeDate)}
          setDate={(date:Date) => this.updateDate(this.state.timeDate, date)}
        />
      }
    </Popover>

    <Menu
      anchorEl={this.iconRef.current}
      open={this.state.iconSelectorOpen}
      anchorReference="anchorEl"
      onClose={() => this.setState({iconSelectorOpen:false})}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      {family
        .filter((person) => (person.role === FamilyMemberType.CHILD || person.role === FamilyMemberType.PARENT 
          || person.role === FamilyMemberType.VIEWER))
        .map((person) =>
        <MenuItem
          key={person.id}
          onClick={() => {
            const newTagged = tagged.filter((t) => t !== person.id);
            if (!tagged.includes(person.id)) {
              newTagged.push(person.id);
            }
            this.setState({tagged:newTagged});
          }}>
          <ListItemIcon>
              <Checkbox
                edge="start"
                checked={this.state.tagged.includes(person.id)}
                tabIndex={-1}
                disableRipple={true}
              />
            </ListItemIcon>
          {<ImgAvatar altText={person.firstName} imgUrl={person.imageAvatar?person.avatarURL:undefined}
            imgName={person.avatar} style={{width:'24px', height:'24px', marginRight:'10px'}} color={person.color} />}

          {person.firstName}
          
        </MenuItem>
      )}
      <Divider key={"divider"}/>
      <MenuItem
          key={"close"}
          onClick={() => this.setState({iconSelectorOpen:false})}>
          {tn.lang.close}          
        </MenuItem>
    </Menu>
    <Menu
      anchorEl={this.repeatRef.current}
      open={this.state.showRepeatMenu}
      anchorReference="anchorEl"
      onClose={() => this.setState({showRepeatMenu:false})}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <MenuItem
        onClick={() => {this.setState({repeat:REPEATABLE.ONCE, showRepeatMenu:false, lastRepeatDate:""});}}>
        <ListItemIcon>
          <Radio
            edge="start"
            checked={this.state.repeat === REPEATABLE.ONCE}
            tabIndex={-1}
            disableRipple={true}
          />
        </ListItemIcon>
        {tn.lang.todoRenewNo}
      </MenuItem>
      <MenuItem
        onClick={() => {
          let repeatC = 2;
          if (!isNaN(parseInt(this.state.repeatCount,10))) {repeatC = parseInt(this.state.repeatCount,10);}
          this.setState({repeat:REPEATABLE.WEEKLY, showRepeatMenu:false, 
            lastRepeatDate:tn.lang.momentNewEvent(this.calcLastEvent(repeatC,REPEATABLE.WEEKLY).getTime())});}}>
        <ListItemIcon>
          <Radio
            edge="start"
            checked={this.state.repeat === REPEATABLE.WEEKLY}
            tabIndex={-1}
            disableRipple={true}
          />
        </ListItemIcon>
        {tn.lang.eventWeekly}
      </MenuItem>
      <MenuItem
        onClick={() => {
          let repeatC = 2;
          if (!isNaN(parseInt(this.state.repeatCount,10))) {repeatC = parseInt(this.state.repeatCount,10);}
          this.setState({repeat:REPEATABLE.BI_WEEKLY, showRepeatMenu:false, 
            lastRepeatDate:tn.lang.momentNewEvent(this.calcLastEvent(repeatC,REPEATABLE.BI_WEEKLY).getTime())});}}>
        <ListItemIcon>
          <Radio
            edge="start"
            checked={this.state.repeat === REPEATABLE.BI_WEEKLY}
            tabIndex={-1}
            disableRipple={true}
          />
        </ListItemIcon>
        {tn.lang.eventBiWeekly}
      </MenuItem>
      <MenuItem
        onClick={() => {
          let repeatC = 2;
          if (!isNaN(parseInt(this.state.repeatCount,10))) {repeatC = parseInt(this.state.repeatCount,10);}
          this.setState({repeat:REPEATABLE.MONTHLY, showRepeatMenu:false, 
            lastRepeatDate:tn.lang.momentNewEvent(this.calcLastEvent(repeatC,REPEATABLE.MONTHLY).getTime())});}}>
        <ListItemIcon>
          <Radio
            edge="start"
            checked={this.state.repeat === REPEATABLE.MONTHLY}
            tabIndex={-1}
            disableRipple={true}
          />
        </ListItemIcon>
        {tn.lang.eventMonthly}
      </MenuItem>
      <MenuItem
        onClick={() => {
          let repeatC = 2;
          if (!isNaN(parseInt(this.state.repeatCount,10))) {repeatC = parseInt(this.state.repeatCount,10);}
          this.setState({repeat:REPEATABLE.FOUR_WEEKS, showRepeatMenu:false, 
            lastRepeatDate:tn.lang.momentNewEvent(this.calcLastEvent(repeatC,REPEATABLE.FOUR_WEEKS).getTime())});}}>
        <ListItemIcon>
          <Radio
            edge="start"
            checked={this.state.repeat === REPEATABLE.FOUR_WEEKS}
            tabIndex={-1}
            disableRipple={true}
          />
        </ListItemIcon>
        {tn.lang.event4Weeks}
      </MenuItem>
      <MenuItem
        onClick={() => {
          let repeatC = 2;
          if (!isNaN(parseInt(this.state.repeatCount,10))) {repeatC = parseInt(this.state.repeatCount,10);}
          this.setState({repeat:REPEATABLE.YEARLY, showRepeatMenu:false, 
            lastRepeatDate:tn.lang.momentNewEvent(this.calcLastEvent(repeatC,REPEATABLE.YEARLY).getTime())});}}>
        <ListItemIcon>
          <Radio
            edge="start"
            checked={this.state.repeat === REPEATABLE.YEARLY}
            tabIndex={-1}
            disableRipple={true}
          />
        </ListItemIcon>
        {tn.lang.eventYearly}
      </MenuItem>
      <Divider key={"divider"}/>
      <MenuItem
        key={"close"}
        onClick={() => this.setState({showRepeatMenu:false})}>
        {tn.lang.close}          
      </MenuItem>
    </Menu>
    <Menu
      anchorEl={this.visibleRef.current}
      open={this.state.visibleForOpen}
      anchorReference="anchorEl"
      onClose={() => this.setState({visibleForOpen:false})}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      {family
        .filter((person) => (person.role === FamilyMemberType.CHILD || person.role === FamilyMemberType.PARENT 
          || person.role === FamilyMemberType.VIEWER))
        .map((person) =>
        <MenuItem
          key={person.id}
          disabled={person.id === userId || person.id === creator}
          onClick={() => {
            const newVisible = visible.filter((t) => t !== person.id);
            if (!visible.includes(person.id)) {
              newVisible.push(person.id);
            }
            const newNotifications = notification.filter((t) => newVisible.includes(t));
            
            this.setState({visible:newVisible, notification:newNotifications});
          }}>
          <ListItemIcon>
              <Checkbox
                edge="start"
                checked={this.state.visible.includes(person.id)}
                tabIndex={-1}
                disableRipple={true}
              />
            </ListItemIcon>
          {<ImgAvatar altText={person.firstName} imgUrl={person.imageAvatar?person.avatarURL:undefined}
            imgName={person.avatar} style={{width:'24px', height:'24px', marginRight:'10px'}} color={person.color} />}
            {person.firstName}
          
        </MenuItem>
      )}
      <Divider key={"divider"}/>
      <MenuItem
        key={"close"}
        onClick={() => this.setState({visibleForOpen:false})}>
        {tn.lang.close}          
      </MenuItem>
    </Menu>
    <Menu
      anchorEl={this.notificationsRef.current}
      open={this.state.showNotificationsMenu}
      anchorReference="anchorEl"
      onClose={() => this.setState({showNotificationsMenu:false})}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      {family
        .filter((person) => (person.role === FamilyMemberType.CHILD || person.role === FamilyMemberType.PARENT 
          || person.role === FamilyMemberType.VIEWER))
        .map((person) =>
        <MenuItem
          key={person.id}
          disabled={(!visible.includes(person.id)) && !notification.includes(person.id) }
          onClick={() => {
            const newNotifications = notification.filter((t) => t !== person.id);
            if (!notification.includes(person.id)) {
              newNotifications.push(person.id);
            }
            this.setState({notification:newNotifications, showNotificationsList:true});
          }}>
          <ListItemIcon>
              <Checkbox
                edge="start"
                checked={this.state.notification.includes(person.id)}
                tabIndex={-1}
                disableRipple={true}
              />
            </ListItemIcon>
          {<ImgAvatar altText={person.firstName} imgUrl={person.imageAvatar?person.avatarURL:undefined}
            imgName={person.avatar} style={{width:'24px', height:'24px', marginRight:'10px'}} color={person.color} />}

          <div style={{display:'flex', flexDirection:'column'}}>
            <span>
              {person.firstName}
            </span>
            <span className={classes.personSubtitle}>
              {(!visible.includes(person.id)) && tn.lang.calEventCantSee}
            </span>
          </div>
          
        </MenuItem>
      )}
      <Divider key={"divider"}/>
      <MenuItem
        key={"close"}
        onClick={() => this.setState({showNotificationsMenu:false})}>
        {tn.lang.close}          
      </MenuItem>
    </Menu>
    <Menu
      anchorEl={this.myNotificationsRef.current}
      open={this.state.showMyNotificationsMenu}
      anchorReference="anchorEl"
      onClose={() => this.setState({showMyNotificationsMenu:false})}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
        <MenuItem
          onClick={() => {
            this.setState(this.updateReminder(userId,0));
          }}>
          <ListItemIcon>
            <Checkbox
              edge="start"
              checked={(this.state.customNotification.findIndex((not) => (not.accountId === userId && not.timeDelta === 0)) > -1)}
              tabIndex={-1}
              disableRipple={true}
            />
          </ListItemIcon>
          <div style={{display:'flex', flexDirection:'column'}}>
            <span>
              {tn.lang.calReminder0Min}
            </span>
          </div>         
        </MenuItem>

        <MenuItem
          onClick={() => {
            this.setState(this.updateReminder(userId,5));
          }}>
          <ListItemIcon>
            <Checkbox
              edge="start"
              checked={(this.state.customNotification.findIndex((not) => (not.accountId === userId && not.timeDelta === 5*60000)) > -1)}
              tabIndex={-1}
              disableRipple={true}
            />
          </ListItemIcon>
          <div style={{display:'flex', flexDirection:'column'}}>
            <span>
              {tn.lang.calReminder5Min}
            </span>
          </div>        
        </MenuItem>

        <MenuItem
          onClick={() => {
            this.setState(this.updateReminder(userId,10));
          }}>
          <ListItemIcon>
            <Checkbox
              edge="start"
              checked={(this.state.customNotification.findIndex((not) => (not.accountId === userId && not.timeDelta === 10*60000)) > -1)}
              tabIndex={-1}
              disableRipple={true}
            />
          </ListItemIcon>
          <div style={{display:'flex', flexDirection:'column'}}>
            <span>
              {tn.lang.calReminder10Min}
            </span>
          </div>     
        </MenuItem>


        <MenuItem
          onClick={() => {
            this.setState(this.updateReminder(userId,15));
          }}>
            <ListItemIcon>
              <Checkbox
                edge="start"
                checked={this.state.notification.includes(userId)}
                tabIndex={-1}
                disableRipple={true}
              />
            </ListItemIcon>
            {tn.lang.calReminder15Min}
        </MenuItem>

        <MenuItem
          onClick={() => {
            this.setState(this.updateReminder(userId,30));
          }}>
          <ListItemIcon>
            <Checkbox
              edge="start"
              checked={(this.state.customNotification.findIndex((not) => (not.accountId === userId && not.timeDelta === 30*60000)) > -1)}
              tabIndex={-1}
              disableRipple={true}
            />
          </ListItemIcon>
          <div style={{display:'flex', flexDirection:'column'}}>
            <span>
              {tn.lang.calReminder30Min}
            </span>
          </div>     
        </MenuItem>

        <MenuItem
          onClick={() => {
            this.setState(this.updateReminder(userId,60));
          }}>
          <ListItemIcon>
            <Checkbox
              edge="start"
              checked={(this.state.customNotification.findIndex((not) => (not.accountId === userId && not.timeDelta === 60*60000)) > -1)}
              tabIndex={-1}
              disableRipple={true}
            />
          </ListItemIcon>
          <div style={{display:'flex', flexDirection:'column'}}>
            <span>
              {tn.lang.calReminder60Min}
            </span>
          </div>     
        </MenuItem>

        <MenuItem
          onClick={() => {
            this.setState(this.updateReminder(userId,120));
          }}>
          <ListItemIcon>
            <Checkbox
              edge="start"
              checked={(this.state.customNotification.findIndex((not) => (not.accountId === userId && not.timeDelta === 120*60000)) > -1)}
              tabIndex={-1}
              disableRipple={true}
            />
          </ListItemIcon>
          <div style={{display:'flex', flexDirection:'column'}}>
            <span>
              {tn.lang.calReminder120Min}
            </span>
          </div>     
        </MenuItem>

        <MenuItem
          onClick={() => {
            this.setState(this.updateReminder(userId,720));
          }}>
          <ListItemIcon>
            <Checkbox
              edge="start"
              checked={(this.state.customNotification.findIndex((not) => (not.accountId === userId && not.timeDelta === 720*60000)) > -1)}
              tabIndex={-1}
              disableRipple={true}
            />
          </ListItemIcon>
          <div style={{display:'flex', flexDirection:'column'}}>
            <span>
              {tn.lang.calReminder12H}
            </span>
          </div>     
        </MenuItem>

        <MenuItem
          onClick={() => {
            this.setState(this.updateReminder(userId,1440));
          }}>
          <ListItemIcon>
            <Checkbox
              edge="start"
              checked={(this.state.customNotification.findIndex((not) => (not.accountId === userId && not.timeDelta === 1440*60000)) > -1)}
              tabIndex={-1}
              disableRipple={true}
            />
          </ListItemIcon>
          <div style={{display:'flex', flexDirection:'column'}}>
            <span>
              {tn.lang.calReminder1Day}
            </span>
          </div>     
        </MenuItem>

        <MenuItem
          onClick={() => {
            this.setState(this.updateReminder(userId,2880));
          }}>
          <ListItemIcon>
            <Checkbox
              edge="start"
              checked={(this.state.customNotification.findIndex((not) => (not.accountId === userId && not.timeDelta === 2880*60000)) > -1)}
              tabIndex={-1}
              disableRipple={true}
            />
          </ListItemIcon>
          <div style={{display:'flex', flexDirection:'column'}}>
            <span>
              {tn.lang.calReminder2Day}
            </span>
          </div>     
        </MenuItem>
      <Divider key={"divider"}/>
      <MenuItem
        key={"close"}
        onClick={() => this.setState({showMyNotificationsMenu:false})}>
        {tn.lang.close}          
      </MenuItem>
    </Menu>
    <Menu
      anchorEl={this.state.updateNotificationRef}
      open={this.state.updateNotificationAccountId != null}
      anchorReference="anchorEl"
      onClose={() => this.setState({updateNotificationRef:null, updateNotificationAccountId:null, updateNotificationCurrentTime:null})}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
        <MenuItem
          onClick={() => {
            const pre = this.updateReminder(this.state.updateNotificationAccountId,this.state.updateNotificationCurrentTime);
            this.setState(this.updateReminder(this.state.updateNotificationAccountId,0, pre.customNotification, pre.notification));
            this.setState({updateNotificationAccountId:null, updateNotificationCurrentTime:null, updateNotificationRef:null});
          }}>
          <ListItemIcon>
            <Checkbox
              edge="start"
              checked={(this.state.updateNotificationCurrentTime === 0)}
              tabIndex={-1}
              disableRipple={true}
            />
          </ListItemIcon>
          <div style={{display:'flex', flexDirection:'column'}}>
            <span>
              {tn.lang.calReminder0Min}
            </span>
          </div>         
        </MenuItem>

        <MenuItem
          onClick={() => {
            const pre = this.updateReminder(this.state.updateNotificationAccountId,this.state.updateNotificationCurrentTime);
            this.setState(this.updateReminder(this.state.updateNotificationAccountId,5, pre.customNotification, pre.notification));
            this.setState({updateNotificationAccountId:null, updateNotificationCurrentTime:null, updateNotificationRef:null});
          }}>
          <ListItemIcon>
            <Checkbox
              edge="start"
              checked={(this.state.updateNotificationCurrentTime === 5)}
              tabIndex={-1}
              disableRipple={true}
            />
          </ListItemIcon>
          <div style={{display:'flex', flexDirection:'column'}}>
            <span>
              {tn.lang.calReminder5Min}
            </span>
          </div>        
        </MenuItem>

        <MenuItem
          onClick={() => {
            const pre = this.updateReminder(this.state.updateNotificationAccountId,this.state.updateNotificationCurrentTime);
            this.setState(this.updateReminder(this.state.updateNotificationAccountId,10, pre.customNotification, pre.notification));
            this.setState({updateNotificationAccountId:null, updateNotificationCurrentTime:null, updateNotificationRef:null});
          }}>
          <ListItemIcon>
            <Checkbox
              edge="start"
              checked={(this.state.updateNotificationCurrentTime === 10)}
              tabIndex={-1}
              disableRipple={true}
            />
          </ListItemIcon>
          <div style={{display:'flex', flexDirection:'column'}}>
            <span>
              {tn.lang.calReminder10Min}
            </span>
          </div>     
        </MenuItem>


        <MenuItem
          onClick={() => {
            const pre = this.updateReminder(this.state.updateNotificationAccountId,this.state.updateNotificationCurrentTime);
            this.setState(this.updateReminder(this.state.updateNotificationAccountId,15, pre.customNotification, pre.notification));
            this.setState({updateNotificationAccountId:null, updateNotificationCurrentTime:null, updateNotificationRef:null});
          }}>
            <ListItemIcon>
              <Checkbox
                edge="start"
                checked={(this.state.updateNotificationCurrentTime === 15)}
                tabIndex={-1}
                disableRipple={true}
              />
            </ListItemIcon>
            {tn.lang.calReminder15Min}
        </MenuItem>

        <MenuItem
          onClick={() => {
            const pre = this.updateReminder(this.state.updateNotificationAccountId,this.state.updateNotificationCurrentTime);
            this.setState(this.updateReminder(this.state.updateNotificationAccountId,30, pre.customNotification, pre.notification));
            this.setState({updateNotificationAccountId:null, updateNotificationCurrentTime:null, updateNotificationRef:null});
          }}>
          <ListItemIcon>
            <Checkbox
              edge="start"
              checked={(this.state.updateNotificationCurrentTime === 30)}
              tabIndex={-1}
              disableRipple={true}
            />
          </ListItemIcon>
          <div style={{display:'flex', flexDirection:'column'}}>
            <span>
              {tn.lang.calReminder30Min}
            </span>
          </div>     
        </MenuItem>

        <MenuItem
          onClick={() => {
            const pre = this.updateReminder(this.state.updateNotificationAccountId,this.state.updateNotificationCurrentTime);
            this.setState(this.updateReminder(this.state.updateNotificationAccountId,60, pre.customNotification, pre.notification));
            this.setState({updateNotificationAccountId:null, updateNotificationCurrentTime:null, updateNotificationRef:null});
          }}>
          <ListItemIcon>
            <Checkbox
              edge="start"
              checked={(this.state.updateNotificationCurrentTime === 60)}
              tabIndex={-1}
              disableRipple={true}
            />
          </ListItemIcon>
          <div style={{display:'flex', flexDirection:'column'}}>
            <span>
              {tn.lang.calReminder60Min}
            </span>
          </div>     
        </MenuItem>

        <MenuItem
          onClick={() => {
            const pre = this.updateReminder(this.state.updateNotificationAccountId,this.state.updateNotificationCurrentTime);
            this.setState(this.updateReminder(this.state.updateNotificationAccountId,120, pre.customNotification, pre.notification));
            this.setState({updateNotificationAccountId:null, updateNotificationCurrentTime:null, updateNotificationRef:null});
          }}>
          <ListItemIcon>
            <Checkbox
              edge="start"
              checked={(this.state.updateNotificationCurrentTime === 120)}
              tabIndex={-1}
              disableRipple={true}
            />
          </ListItemIcon>
          <div style={{display:'flex', flexDirection:'column'}}>
            <span>
              {tn.lang.calReminder120Min}
            </span>
          </div>     
        </MenuItem>

        <MenuItem
          onClick={() => {
            const pre = this.updateReminder(this.state.updateNotificationAccountId,this.state.updateNotificationCurrentTime);
            this.setState(this.updateReminder(this.state.updateNotificationAccountId,720, pre.customNotification, pre.notification));
            this.setState({updateNotificationAccountId:null, updateNotificationCurrentTime:null, updateNotificationRef:null});
          }}>
          <ListItemIcon>
            <Checkbox
              edge="start"
              checked={(this.state.updateNotificationCurrentTime === 720)}
              tabIndex={-1}
              disableRipple={true}
            />
          </ListItemIcon>
          <div style={{display:'flex', flexDirection:'column'}}>
            <span>
              {tn.lang.calReminder12H}
            </span>
          </div>     
        </MenuItem>

        <MenuItem
          onClick={() => {
            const pre = this.updateReminder(this.state.updateNotificationAccountId,this.state.updateNotificationCurrentTime);
            this.setState(this.updateReminder(this.state.updateNotificationAccountId,1440, pre.customNotification, pre.notification));
            this.setState({updateNotificationAccountId:null, updateNotificationCurrentTime:null, updateNotificationRef:null});
          }}>
          <ListItemIcon>
            <Checkbox
              edge="start"
              checked={(this.state.updateNotificationCurrentTime === 1440)}
              tabIndex={-1}
              disableRipple={true}
            />
          </ListItemIcon>
          <div style={{display:'flex', flexDirection:'column'}}>
            <span>
              {tn.lang.calReminder1Day}
            </span>
          </div>     
        </MenuItem>

        <MenuItem
          onClick={() => {
            const pre = this.updateReminder(this.state.updateNotificationAccountId,this.state.updateNotificationCurrentTime);
            this.setState(this.updateReminder(this.state.updateNotificationAccountId,2880, pre.customNotification, pre.notification));
            this.setState({updateNotificationAccountId:null, updateNotificationCurrentTime:null, updateNotificationRef:null});
          }}>
          <ListItemIcon>
            <Checkbox
              edge="start"
              checked={(this.state.updateNotificationCurrentTime === 2880)}
              tabIndex={-1}
              disableRipple={true}
            />
          </ListItemIcon>
          <div style={{display:'flex', flexDirection:'column'}}>
            <span>
              {tn.lang.calReminder2Day}
            </span>
          </div>     
        </MenuItem>
      <Divider key={"divider"}/>
      <MenuItem
        key={"close"}
        onClick={() => this.setState({updateNotificationAccountId:null, updateNotificationCurrentTime:null, updateNotificationRef:null})}>
        {tn.lang.close}          
      </MenuItem>
    </Menu>
    <Dialog
      open={ this.state.confirm !== undefined}
      onClose={() => this.setState({confirm:undefined})}
    >
      <DialogTop>
        <DialogTitle>{this.state.confirm === "DELETE"
          ?tn.lang.calEventEraseAll
          :tn.lang.calEventUpdateAll}</DialogTitle>
        <IconButton onClick={() => this.setState({confirm:undefined})}>
          <CloseIcon />
        </IconButton>
      </DialogTop>
      <div style={{display: 'flex', flexDirection: 'column', padding: '16px', gap: '16px'}}>
        <Button variant="outlined" classes={{outlined:classes.buttonOutlined}} onClick={() => {
          if (this.state.confirm === "DELETE") {this.delete("ALL");}
          else {this.save("ALL");}
        }}>
          {this.state.confirm === "DELETE"
            ?tn.lang.calEventConfirmEraseAll
            :tn.lang.calEventConfirmUpdateAll}
        </Button>
        {this.state.confirm === "DELETE" &&
          <Button variant="outlined" classes={{outlined:classes.buttonOutlined}} onClick={() => this.delete("FOLLOWING")}>
            {tn.lang.calEventConfirmEraseFollowing}
          </Button>}
        <Button variant="contained" classes={{contained:classes.buttonContained}} color="primary" onClick={() => {
          if (this.state.confirm === "DELETE") {this.delete("ONE");}
          else {this.save("ONE");}
        }}>
          {tn.lang.calEventOnlyThis}
        </Button>
      </div>
    </Dialog>
    </>);
  }

  private computeOverlaps():IEvent[] {
    const overlapStart = this.state.dateStart.getTime();
    const overlapEnd = this.state.dateEnd.getTime();
    if (overlapStart > overlapEnd) {
      return [];
    }
    return this.props.allEvents
      .filter((ev) => ev.id !== this.state.id
        && ev.eventType !== EVENT_TYPE.SCHOOL_HOLIDAY
        && ev.startTime < overlapEnd && overlapStart < ev.endTime)
      .sort((a, b) => a.startTime - b.startTime);
  }

  private notifyOverlaps() {
    if (!this.props.onOverlapsChange) {
      return;
    }
    const overlaps = this.computeOverlaps();
    const key = overlaps.map((ev) => ev.id).join(",");
    if (key !== this.lastOverlapKey) {
      this.lastOverlapKey = key;
      this.props.onOverlapsChange(overlaps);
    }
  }

  private delete(confirmed:"ALL"|"ONE"|"FOLLOWING"|undefined) {
    if (this.state.groupId === undefined || this.state.groupId < 1) {
      this.props.deleteEvent({id:this.state.id});
      this.props.close("CLOSE");
    } else if (confirmed === undefined) {
      this.setState({confirm:"DELETE"});
    } else if (confirmed === "ONE") {
      this.props.deleteEvent({id:this.state.id});
      this.props.close("CLOSE");
    } else if (confirmed === "FOLLOWING") {
      this.props.deleteEvent({groupId:this.state.groupId, id:this.state.id, thisAndFollowing:true});
      this.props.close("CLOSE");
    } else if (confirmed === "ALL") {
      this.props.deleteEvent({groupId:this.state.groupId, id:this.state.id});
      this.props.close("CLOSE");
    }
  }

  private saveOrUpload(confirmed:"ALL"|"ONE"|undefined) {
    if (this.state.nativeURL !== '' && this.editorRef.current) {
      this.setState({saveClicked:true});

      try {
        const canvas = document.createElement('canvas');
          canvas.width = 900;
          canvas.height = 900;

        const context = canvas.getContext('2d');
        const areaLimit = (this.editorRef.current.getImage().width > 4095 || this.editorRef.current.getImage().height > 4095);

        if (context !== null) {
          context.drawImage(areaLimit 
            ? this.editorRef.current.getImageScaledToCanvas() 
            : this.editorRef.current.getImage(), 0, 0, 900, 900);
        }

        canvas.toBlob((blob) => {
          if(blob && this.editorRef.current){
            const d = handleBlobUpload(blob, "event.png", this.props.uploadFile);
            this.setState({internalUploadId: d.internalId})
          }
        })
      } catch (error) {
        this.props.displayErrorMessage("Error uploading image.");
        this.setState({saveClicked:false, internalUploadId:undefined});
      }
    } else {
      this.save(confirmed);
    }

  }


  private save(confirmed:"ALL"|"ONE"|undefined) {
    if (this.state.groupId === undefined || this.state.groupId < 1) {
      if (this.state.id > 0) {
        setTimeout(() => {
          this.confirmedUpdate(false);
          this.props.close("CREATED");
        },100);
      } else {
        setTimeout(() => {
          let occurences =  1;
          if (this.state.repeat !== REPEATABLE.ONCE) {
            if (!isNaN(parseInt(this.state.repeatCount,10))) {
              occurences = parseInt(this.state.repeatCount,10);
            }
          }

          let eventType:EVENT_TYPE = EVENT_TYPE.NORMAL;
          if (this.props.analysedEvent !== undefined) {
            eventType = EVENT_TYPE.AI;
          }

          let fileId = this.state.fileId;
          if (fileId === undefined && this.props.analysedEvent !== undefined && this.props.analysedEvent.fileId !== undefined) {
            fileId = this.props.analysedEvent.fileId;
          }


          this.props.createEvent({
            title:this.state.title,
            description:this.state.description.trim().length === 0?undefined:this.state.description,
            hasTime:this.state.hasTime,
            startTime:this.state.startTime,
            endTime:this.state.endTime,
            visible:this.state.visible,
            tagged:this.state.tagged,
            notification:this.state.notification,
            customNotification:this.state.customNotification,
            privacy:PRIVACY.ALL,
            occurences,
            frequency:this.state.repeat,
            checkmark:this.state.checkmark,
            completedBy:this.state.completedBy,
            fileId,
            eventType,
          }); 
          setTimeout(() => {
            this.props.close("CREATED"); 
          }, 100);
          if (this.state.fileId) {
            this.props.uploadedFileUsed(this.state.fileId);
          }
          
        },100);
      }
    } else if (confirmed === undefined) {
      this.setState({confirm:"UPDATE"});
    } else if (confirmed === "ONE") {
      this.confirmedUpdate(false);
      this.props.close("CREATED");
    } else if (confirmed === "ALL") {
      this.confirmedUpdate(true);
      this.props.close("CREATED");
    }
  }

  private updateLocalImage = async (event: any) => {
    const { files } = event.target;
    if ((files && files.length > 0) || (event.files && event.files.length > 0)) {
      const f:File | null = files?.item(0) ? files.item(0) : event.files.item(0);
      if (!f) {
        return;
      }

      const mime = (f.type || mimeFromFilename(f.name)).toLowerCase();
      const mimeIsMissing = !f.type || f.type.trim().length === 0;

      if (mime.includes("image") || mimeIsMissing) {
        const data = await fileToBase64(f);
        const dataMime = mime.includes("image") ? mime : "image/jpeg";
        this.setState({nativeURL: 'data:'+dataMime+';base64,'+data});
      } else if (mime.includes("video")) {
        this.props.displayErrorMessage("Videos not supported yet");
      }
    }
  }

  private confirmedUpdate(all:boolean) {
    this.props.editEvent({
      id:this.state.id,
      groupId:(all?this.state.groupId:undefined),
      modifyGroup:all,
      title:this.state.title,
      description:this.state.description.trim().length === 0?undefined:this.state.description,
      hasTime:this.state.hasTime,
      startTime:this.state.startTime,
      endTime:this.state.endTime,
      privacy:PRIVACY.ALL,
      visible:this.state.visible,
      tagged:this.state.tagged,
      notification:this.state.notification,
      customNotification:this.state.customNotification,
      checkmark:this.state.checkmark,
      completedBy:this.state.completedBy,
      fileId:this.state.fileId,
    });
    if (this.state.fileId) {
      this.props.uploadedFileUsed(this.state.fileId);
    }
  }

  private validToSave():boolean {
    const {id,title,description,startTime,endTime,hasTime,visible,tagged,notification, customNotification, checkmark, fileId} = this.state;
    const isOnline = this.props.isOnline;
    if (!isOnline) {
      return false;
    }

    const event = this.props.event;
    if (id > 0) { // editing an existing event

      let customNotDiff:boolean = false;
      if (event !== undefined) {
        const origCustNot = event.customNotification?event.customNotification:[];
        if (customNotification.length !== origCustNot.length) {
          customNotDiff = true;
        } else {
          origCustNot.sort((a,b) => (a.timeDelta - b.timeDelta) + (a.accountId - b.accountId));
          customNotification.sort((a,b) => (a.timeDelta - b.timeDelta) + (a.accountId - b.accountId));
          for (let index = 0; index < origCustNot.length; index++) {
            const onot = origCustNot[index];
            const nnot = customNotification[index];
            if (onot.accountId !== nnot.accountId || onot.timeDelta !== nnot.timeDelta) {
              customNotDiff = true;
              break;
            }
          }
        }
  
      }

      if (event !== undefined && visible.includes(this.props.userId) && (
        title !== event.title || 
        description !== (event.description?event.description:"") || 
        startTime !== event.startTime || 
        endTime !== event.endTime || 
        hasTime !== event.hasTime || 
        this.state.nativeURL !== "" ||
        fileId !== (event.file?event.file.id:undefined) ||
        checkmark !== event.checkmark || 
        (visible.sort().join(',') !== (event.visible?event.visible:[]).sort().join(',')) || 
        (tagged.sort().join(',') !== (event.tagged?event.tagged:[]).sort().join(',')) || 
        customNotDiff || 
        (notification.sort().join(',') !== (event.notification?event.notification:[]).sort().join(',')))) {
          return true;
      }
      return false;
    } else {
      if (title.trim().length === 0 || 
        visible.length === 0 || 
        !visible.includes(this.props.userId) || 
        startTime > endTime
      ) {
        return false;
      }
      return true;
    }
    
  }

  private getHourMinute(time:"STARTTIME"|"STARTDATE"|"ENDTIME"|"ENDDATE"|null, value:"HOUR"|"MINUTE"):number {
    if (time === "STARTDATE" || time === "STARTTIME") {
      if (value === "HOUR"){
        return this.state.dateStart.getHours();
      }
      return this.state.dateStart.getMinutes();
    } else if (time === "ENDDATE" || time === "ENDTIME") {
      if (value === "HOUR"){
        return this.state.dateEnd.getHours();
      }
      return this.state.dateEnd.getMinutes();
    }
    return 0;
  }

  private getDate(time:"STARTTIME"|"STARTDATE"|"ENDTIME"|"ENDDATE"|null):Date {
    if (time === "STARTDATE" || time === "STARTTIME") {
      return this.state.dateStart;
    } else if (time === "ENDDATE" || time === "ENDTIME") {
      return this.state.dateEnd;
    }
    return new Date();
  }

  private updateTimeFullday() {
    const start = new Date(this.state.dateStart);
    const end = new Date(this.state.dateEnd);

    start.setHours(0);
    start.setMinutes(0);
    end.setHours(23);
    end.setMinutes(59);

    this.setState({dateStart:start, dateEnd:end, startTime:start.getTime(), endTime:end.getTime(), hasTime:false});
  }

  private updateTime(time:"STARTTIME"|"STARTDATE"|"ENDTIME"|"ENDDATE"|null, hour:number|null, minute:number|null) {
    if (time === "STARTDATE" || time === "STARTTIME") {
      const newDate = new Date(this.state.dateStart);
      if (hour !== null) {
        newDate.setHours(hour);
      }
      if (minute !== null) {
        newDate.setMinutes(minute);
      }
      this.setState({dateStart:newDate, hasTime:true});
    } else if (time === "ENDDATE" || time === "ENDTIME") {
      const newDate = new Date(this.state.dateEnd);
      if (hour !== null) {
        newDate.setHours(hour);
      }
      if (minute !== null) {
        newDate.setMinutes(minute);
      }
      this.setState({dateEnd:newDate, hasTime:true});
    } 
  }

  private updateDate(time:"STARTTIME"|"STARTDATE"|"ENDTIME"|"ENDDATE"|null, date:Date) {
    if (time === "STARTDATE") {
      date.setHours(this.state.dateStart.getHours());
      date.setMinutes(this.state.dateStart.getMinutes());
      this.setState({dateStart:date});
    } else if (time === "ENDDATE") {
      date.setHours(this.state.dateEnd.getHours());
      date.setMinutes(this.state.dateEnd.getMinutes());
      this.setState({dateEnd:date});
    } 
  }

  private updateDescSize() {
    const area = this.descRef.current;
    if (area) {
      area.style.maxHeight = "0px";
      area.style.height = "0px";
      area.style.minHeight = "0px";
      area.style.padding = "0px 6px";
      const scrollHeight = Math.min(Math.max(area.scrollHeight,16),60);
      area.style.padding = "6px";
      area.style.maxHeight = scrollHeight+"px";
      area.style.height = scrollHeight+"px";
      area.style.minHeight = scrollHeight+"px";
    }
  }

  private onBlur(lastTouched:"STARTDATE"|"STARTTIME"|"ENDDATE"|"ENDTIME"|null) {

    const start = new Date(this.state.dateStart);
    const end = new Date(this.state.dateEnd);

    if (start.getTime() > end.getTime()) {

      const timeDiff = Math.min(Math.abs(this.state.endTime - this.state.startTime),(1000*60*60*2));

      if (lastTouched === "STARTDATE" || lastTouched === "STARTTIME") {
        end.setTime(start.getTime() + (timeDiff));
      } else {
        start.setTime(end.getTime() - (timeDiff));
      }
    }    
    if (lastTouched === "STARTDATE" 
      && (start.getTime() < (end.getTime() - (1000*60*60*24*300)) 
        || start.getTime() > (end.getTime() + (1000*60*60*24*300)))) {
      end.setFullYear(start.getFullYear());
    }

    this.setState({startTime:start.getTime(), endTime:end.getTime(), dateStart:start, dateEnd:end});
  }

  private calcLastEvent = (repeatCount:number, repeat:REPEATABLE) => {
    let endDate: Date = new Date(this.state.startTime);
    switch (repeat) {
      case REPEATABLE.WEEKLY:
        endDate = addDays(endDate, (7 * (repeatCount - 1)));
        break;
      case REPEATABLE.BI_WEEKLY:
        endDate = addDays(endDate, (14 * (repeatCount - 1)));
        break;
      case REPEATABLE.FOUR_WEEKS:
        endDate = addDays(endDate, (28 * (repeatCount - 1)));
        break;
      case REPEATABLE.MONTHLY:
        endDate = addMonths(endDate, (repeatCount - 1));
        break;
      case REPEATABLE.YEARLY:
        endDate = addDays(endDate, (365 * (repeatCount - 1)));
        break;
    }

    return endDate;
  }

  private updateVisible(accountId:number, add:boolean) {
    const vis = this.state.visible.filter((v) => v !== accountId);
    if (add) {
      vis.push(accountId);
    }
    const not = this.state.notification.filter((v) => vis.includes(v));
    const notif = this.state.customNotification.filter((cn) => vis.includes(cn.accountId));
    let showOthersNotif = this.state.showNotificationsList;
    if (add && !not.includes(accountId) && notif.findIndex((n) => n.accountId === accountId) === -1) {
      not.push(accountId);
      showOthersNotif = true;
    }
    this.setState({visible:vis, notification:not, customNotification:notif});
  }

  private updateReminder(accountId:number|null, minutes:number|null, customNotification?:IEventNotification[], notification?:number[]): 
    {customNotification:IEventNotification[], notification:number[]} {

    if (accountId === null || minutes === null) {
      return {notification:this.state.notification, customNotification:this.state.customNotification};
    }
    if (minutes === 15) {
      const origNot = notification?notification:this.state.notification;
      const not = origNot.filter((v) => (v !== accountId && this.state.visible.includes(v)));
      if (!this.state.notification.includes(accountId) && this.state.visible.includes(accountId)) {
        not.push(accountId);
      }
      return {notification:not, customNotification:customNotification?customNotification:this.state.customNotification};
    } else {
      const deltaTime = (minutes*1000*60);
      const origNot = customNotification?customNotification:this.state.customNotification;
      const newCustomeNotifications:IEventNotification[] = origNot.filter((n) => (this.state.visible.includes(n.accountId)));
      
      const index = newCustomeNotifications.findIndex((n) => n.accountId === accountId && n.timeDelta === deltaTime);
      if (index === -1) {
        newCustomeNotifications.push({accountId, timeDelta:deltaTime});
      } else {
        newCustomeNotifications.splice(index,1);
      }
      newCustomeNotifications.sort((a,b) => (a.timeDelta - b.timeDelta) + (a.accountId - b.accountId));
      return {customNotification:newCustomeNotifications, notification:notification?notification:this.state.notification};
    }
  }

  private hasReminder(accountId:number, minutes:number):boolean {

    if (minutes === 15) {
      return this.state.notification.includes(accountId);
    } else {
      const deltaTime = (minutes*1000*60);
      for (const notification of this.state.customNotification) {
        if (notification.accountId === accountId && notification.timeDelta === deltaTime) {
          return true;
        }
      }
      return false;
    } 
  }

  private openAnalysedFile() {
    if (this.props.analysedEvent === undefined || !this.props.analysedEvent.fileUrl) {return;}
    openFileInNewTab(this.props.analysedEvent.fileUrl);
  }

  private createEmptyEvent(onDay:Date|undefined, userId:number) {

    const dateCopy = new Date(onDay?onDay:(new Date()));
    dateCopy.setHours(13);
    dateCopy.setMinutes(0);
    dateCopy.setSeconds(0);
    dateCopy.setMilliseconds(0);

    const startTime = dateCopy.getTime();

    dateCopy.setHours(14);

    const endTime = dateCopy.getTime();

    const visible:number[] = [];
    const tagged:number[] = [];
    const notification:number[] = [];

    for (const mem of this.props.family) {
      if (mem.role === FamilyMemberType.CHILD) {
        tagged.push(mem.id);
        visible.push(mem.id);
        notification.push(mem.id);
      } else if (mem.role === FamilyMemberType.PARENT) {
        visible.push(mem.id);
        notification.push(mem.id);
      } else if (mem.role === FamilyMemberType.VIEWER) {
        visible.push(mem.id);
      }
    }

    const emptyEvent:IEvent = {
      id:0,
      title:"",
      description:"",
      hasTime:true,
      startTime,
      endTime,
      privacy:PRIVACY.ALL,
      visible,
      tagged,
      notification,
      seen:[],
      creator:userId,
      checkmark:false,
      completedBy:undefined,
    };
    return emptyEvent;
  }
}


function yellowDot(hasGlow:boolean, show:boolean) {
  if (hasGlow && show) {
    return(<div style={{minWidth: '8px', minHeight: '8px', backgroundColor: styleColors.handoverYellow, borderRadius: '10px',
      maxWidth: '8px', maxHeight: '8px', marginLeft: '2px'}}/>);
  } else {
    return(<div />);
  }
}


function mapStateToProps(state: any) {
  const userId = state.user.session.data.id;

  return {
    userId,
    family:state.family.family,
    uploadingFiles: state.file.uploadSlots,
    uploadedFiles: state.file.uploadedFiles,
    isOnline: state.connection.loadCompleted,
    allEvents: state.event.events ? state.event.events : [],
  };
}

const mapDispatchToProps = {
  createEvent: EventActions.createEvent,
  deleteEvent: EventActions.deleteEvent,
  editEvent: EventActions.editEvent,
  uploadFile: FileActions.requestFileUpload,
  uploadedFileUsed: FileActions.uploadedFileUsed,
  removeStoredFile: FileActions.removeStoredFile,
  displayErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(EditEventStyle)(EditEvent));



// WEBPACK FOOTER //
// ./src/components/calendar2/eventdetails/EditEvent.tsx